export enum Priority {
    Critical = 1,
    Urgent = 2,
}
